export default "__VITE_ASSET__BWBl3vNT__"